import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="w-full bg-charcoal-950 py-12 sm:py-16" aria-labelledby="guarantee-title" data-id="element-83" data-mp="4uqdmw6js2tb">
      <div className="mx-auto max-w-2xl px-5 text-center" data-id="element-84" data-mp="9tbduvlsumhr">
        <ShieldCheckIcon className="mx-auto h-8 w-8 text-champagne" strokeWidth={1.25} aria-hidden="true" data-id="element-85" data-mp="etfy8wptw1d9" />
        <h2 id="guarantee-title" className="mt-4 font-display text-[1.6rem] font-semibold uppercase leading-tight text-ivory-50 sm:text-[2.25rem]" data-id="element-86" data-mp="jrr651wkc1su">
          7-Day guarantee
        </h2>
        <p className="mx-auto mt-3 max-w-lg text-[14px] leading-relaxed text-body sm:text-[15px]" data-id="element-87" data-mp="sldw2be3aau4">
          Explore BREAK FREE™ and see if it's right for you. If it isn't, request your
          refund within 7 days.
        </p>
      </div>
    </section>;
}